module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab15/awsop-lab15.component.css
// module id = ./src/app/course/labs/awsop/awsop-lab15/awsop-lab15.component.css
// module chunks = main